import DeductionPlanResource from "./deductionPlan.resource";

const deductionPlanModule = angular
  .module("app.resources.deductionPlan", [])
  .service("DeductionPlan", DeductionPlanResource);

export default deductionPlanModule;



// WEBPACK FOOTER //
// ./src/resources/deductionPlan/deductionPlan.module.js